import { render, staticRenderFns } from "./MyManuscript.vue?vue&type=template&id=a2bb5cf0&scoped=true"
import script from "./MyManuscript.vue?vue&type=script&lang=js"
export * from "./MyManuscript.vue?vue&type=script&lang=js"
import style0 from "./MyManuscript.vue?vue&type=style&index=0&id=a2bb5cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bb5cf0",
  null
  
)

export default component.exports